export const FEELING_ITEM_VERSION = 'feeling-items-0.1.0';
export const FEELING_PORTRAIT_RATIO = 2 / 3;
const moods = new Set(['calm', 'inspired', 'energized']);
const shapes = new Set(['circle', 'arcs', 'orbit']);

/** Whitelist authored visual cues. This describes an optional activity, never a
 * reader's state or a promise of benefit. Invalid metadata falls back to a poster. */
export function feelingItem(input) {
  if (
    !input ||
    input.version !== FEELING_ITEM_VERSION ||
    !moods.has(input.mood) ||
    !shapes.has(input.shape) ||
    typeof input.prompt !== 'string' ||
    !input.prompt.trim() ||
    input.prompt.length > 180
  )
    return null;
  return {
    version: FEELING_ITEM_VERSION,
    mood: input.mood,
    shape: input.shape,
    prompt: input.prompt.trim(),
  };
}

/** Evaluate a bounded, smooth cue from injected active milliseconds. Calm uses
 * equal four- or five-second phases without holds; neither is a medical optimum.
 * Other moods provide visual attention cues, not faster breathing instructions. */
export function feelingFrame(config, elapsedMs, breathSeconds = 4) {
  const item = feelingItem(config);
  if (!item || !Number.isFinite(elapsedMs) || elapsedMs < 0 || ![4, 5].includes(breathSeconds))
    throw new RangeError('Invalid feeling cue clock.');
  const seconds = item.mood === 'calm' ? breathSeconds : item.mood === 'inspired' ? 8 : 6;
  const phase = (elapsedMs / (seconds * 1000)) % 2;
  const progress = phase < 1 ? phase : 2 - phase;
  const eased = (1 - Math.cos(Math.PI * progress)) / 2;
  return {
    scale: 0.78 + 0.22 * eased,
    imageScale: 1 + 0.018 * eased,
    phase:
      item.mood === 'calm' ? (phase < 1 ? 'Breathe in gently' : 'Breathe out gently') : item.prompt,
    count: Math.min(seconds, 1 + Math.floor((phase % 1) * seconds)),
  };
}
